import ReactGA from "react-ga4";
import cookies from "./cookies";

let gaKey = cookies.getAgentInfo()?.ga;
// let gaKey = null;

if (gaKey){
  ReactGA.initialize(gaKey, {
    // debug: true,
    gaOptions: {
      siteSpeedSampleRate: 100
    }
  });
}

function ga(pathname, title, trackerNames = [], options = {}) {
  if (!gaKey) return;
  ReactGA.set({ pathname, ...options });
  
  ReactGA.send({
    hitType: 'pageview',
    page: pathname
  });
}

export {ga};
